import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { srBodyTemplate, CommonBodyForTable, commonFormDialogFooter } from "../Common/CommonComponents";
import ApiServices from "../../service/api/ApiServices";
import { Dialog } from "primereact/dialog";
import { CommonForDetails } from "../CRM/Leads";
import { Toast } from "primereact/toast";
import { failureToast, successToast } from "../Common/CommonFunctions";
import { OrderDetails } from "./OrderDetails";
import { Toolbar } from "primereact/toolbar";
const saved = localStorage.getItem("user");

// Parse the saved user data from localStorage.
// This is typically used to get user information or authentication details.
const initialValue = JSON.parse(saved);

// Create an instance of ApiServices to use its methods for API calls.
// Assuming ApiServices is a class th   at handles API requests.
const apiServices = new ApiServices()

/** * SalesMemberOrders component to display a list of SalesMemberOrders in a data table.
 * It fetches the SalesMemberOrders data from the API and displays it in a paginated table format.
 * It also includes a search functionality to filter the SalesMemberOrders based on their names or other attributes.
 */
export const SalesMemberOrders = (props) => {

    const [ordersList, setSalesMemberOrdersList] = useState(null)
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('');
    const [viewSalesMemberDialog, setViewSalesMemberDialog] = useState(false);
    const [order, setOrder] = useState({
        user_id: '',
        order_no: '',
    });

    // Create a ref for the toast component to show notifications.
    const toast = useRef(null);
    const dataRef = useRef(null);


    useEffect(() => {
        getSalesMemberOrders(props.data)
    }, [props])

    const tableStyle = { overflowX: 'scroll', width: '100%' };

    const exportCSV = () => {
        dataRef.current.exportCSV();
    }

    const header = (
        <div className="table-header">
            <span className="p-input-icon-right">
                <h6 className="p-mt-3 p-mr-5">Orders</h6>
            </span>
            <span className="p-input-icon-left">
                <div className="p-inputgroup">
                    <Button className='custom-group-btn' icon="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                    <Button className='custom-group-btn p-button-rounded p-m-2' onClick={() => { exportCSV(dataRef) }} icon="pi pi-download"></Button>
                </div>
            </span>
        </div>
    )

    /**
     * Function to fetch SalesMemberOrders data from the API
     * and update the state with the fetched data.
     */
    const getSalesMemberOrders = async (data = {}) => {
        setLoading(true)
        let obj = {}
        if(data){
            obj.user_id = data.id
        }
        const response = await apiServices.getGSFOrderDetails(obj)   // Assuming this API returns the SalesMemberOrders data
        if (response?.data?.response_obj.length > 0) {
            setSalesMemberOrdersList(response.data.response_obj)
        } else {
            setSalesMemberOrdersList([])
        }
        setLoading(false)
    }

    const openOrderDetails = (rowData) => {
        setOrder({
            user_id: rowData.customer_id,
            order_no: rowData.order_no,
        });
        setViewSalesMemberDialog(true);
    }

    /** * Function to render the action buttons for each row in the data table.
     * It includes Edit and View buttons with appropriate styles and actions.
     * @param {Object} rowData - The data of the current row.
     * @returns JSX element containing action buttons.
     */
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Actions</span>
                <div className="actions" style={{ display: "flex" }}>
                    <Button icon="pi pi-eye" title='View Details' className="p-button-rounded p-button-info p-mx-2" aria-label="View Details" onClick={() => { openOrderDetails(rowData) }} />
                </div>
            </>
        );
    }

    /**
     * Function to handle the visibility of the view sales member dialog.
     * It sets the state to show or hide the dialog based on the parameter passed.
     * @param {boolean} value - The value to set the visibility of the dialog.
     */
    const hideviewDialog = () => {
        setViewSalesMemberDialog(false);
    }


    /**
     * Function to render the footer of the view sales member dialog.
     * It includes Cancel and View buttons with appropriate actions.
     */
    const viewSalesFooter = commonFormDialogFooter('Close', hideviewDialog, 'Okay', 'view-SalesMember-form')


    const rightToolbarTemplate = () => {
        return (
            <>
                {/* <Button label="Place Order" icon="pi pi-user-edit" className="p-custom-btn p-ml-2" onClick={() => () => { }} /> */}
            </>
        )
    }


    return (

        <>
            <div className="p-grid crud-demo">
                <div className="p-col-12">
                    <div className="card">
                        <Toast ref={toast} position="center" />
                        {
                            loading ?
                                <>
                                    <div className="spinner-div">
                                        <center><ProgressSpinner strokeWidth="7" animationDuration='4s' /></center>
                                    </div>
                                </>
                                :
                                <>
                                    {/* <Toolbar className="p-mb-4 p-toolbar" right={rightToolbarTemplate}></Toolbar> */}
                                    <DataTable style={tableStyle} className="datatable-responsive" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                                        value={ordersList} dataKey="id" exportFilename={`Orders`}
                                        loading={loading} globalFilter={globalFilter} filterDisplay="menu" header={header} ref={dataRef}>
                                        <Column field="srid" header="Sr.No." body={srBodyTemplate} style={{ width: '1rem' }} exportable={true}></Column>
                                        <Column field="personal_first_name" header="First Name" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                        <Column field="personal_last_name" header="Last Name" body={CommonBodyForTable} style={{ width: '2rem' }} exportable={true}></Column>
                                        <Column field="order_no" header="Order Number" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="createdAt" header="Created At" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="payment_status" header="Payment Status" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="status" header="Status" body={CommonBodyForTable} style={{ width: '3rem' }} exportable={true}></Column>
                                        <Column field="razorpay_amount" header="Razorpay Amount" body={CommonBodyForTable} style={{ width: '4rem' }} exportable={true}></Column>
                                        <Column field="action" header="Actions" body={actionBodyTemplate} style={{ width: '2rem' }}></Column>
                                    </DataTable>
                                </>
                        }

                        <Dialog visible={viewSalesMemberDialog} style={{ width: '100%' }} header={`${order.order_no}`} modal footer={viewSalesFooter} onHide={hideviewDialog}>
                            <OrderDetails order={order} />
                        </Dialog>

                    </div>
                </div>
            </div>
        </>
    )
}